import { useEffect, useState } from "react";
import { readStepPlans, type ThreadStepPlan } from "../../../../api/threads/threadsApi";
import { loadAfterTypingPause } from "../../../../shared/loading/afterTypingPause";

/**
 * The current step's plan with the values changed for its next run (ADR-0032 D7): module B
 * says whether they fill what it needs, so Run follows its answer, not a rule of the web app.
 * `null` while nothing is changed or the answer has not come; read again once typing settles
 * and when the log moves. `values` is read again when it changes by identity.
 */
export function useDraftStepPlan(threadId: string, stepKey: string | null, values: Readonly<Record<string, unknown>>, lastEntryNumber: number): ThreadStepPlan | null {
  const request = stepKey === null || Object.keys(values).length === 0 ? null : JSON.stringify([threadId, stepKey, values, lastEntryNumber]);
  const [answer, setAnswer] = useState<{ readonly request: string; readonly plan: ThreadStepPlan | null } | null>(null);
  useEffect(() => {
    if (request === null || stepKey === null) return undefined;
    return loadAfterTypingPause(
      (signal) => readStepPlans(threadId, { stepKey, values }, signal),
      (next) => { if (next.status === "loaded") setAnswer({ request, plan: next.value.find((plan) => plan.stepKey === stepKey) ?? null }); },
    );
  }, [request, threadId, stepKey, values]);
  return request !== null && answer?.request === request ? answer.plan : null;
}
